// 플랫폼 값을 한 번만 계산하여 캐시
const PLATFORM = process.env.NEXT_PUBLIC_PLATFORM || 'PC';
const IS_MOBILE = PLATFORM === 'MOBILE';

export function useIsMobile() {
  return IS_MOBILE;
}
